<template>
  <div class="new">
    <div class="title">
      <VTitle page-title="课程相关"></VTitle>
    </div>

    <div class="content">
      <div>
        <div class="head">

        </div>
        <div class="content1">
          <p v-html=" this.result.courseSummary"></p>
          <!-- <p v-text="55"></p>
          <p v-text="66"></p> -->
        </div>

        <!-- <div class="head1">

        </div> -->
        <!-- <div class="content2">
          <div class="detail">
            <div class="detail2" v-for="obj,index in this.result.detalis" :key="index" v-text="obj.created_at + ' ' +  obj.total_course +' '+ obj.presented_course"></div>
          </div>
        </div> -->
      </div>
    </div>
    <div>
      <VGoBackBtn></VGoBackBtn>
    </div>

  </div>
</template>

<script type="text/ecmascript-6">
  import VTitle from '../../components/VTitle.vue';
  import VGoBackBtn from '../../components/VGoBackBtn.vue';
  import Teacher from '../../api/teacher';
  import netTool from '../../api/netTool';
  import { Toast } from 'mint-ui';
  export default {
    data () {
      return {
        result:{}
      };
    },
    created () {
      this.getData();
    },
    components: {VTitle, VGoBackBtn},
    methods: {
      getData () {
        Teacher.getStudentProfileInfo().then(response => {
            this.result = response.rows[0];
        }).catch(e => {
            console.log(e);
        });
        // netTool.courseAbout().then(response => {
        //   if (response.errno === '0') {
        //     this.result = response.result;
        //   } else {
        //     Toast({message: response.message, position: 'middle', duration: 3000});
        //   }
        // })
        // .catch(error => {
        //   console.log(error);
        // });
      },
//       getLocalTime(tm) {
//         let d = new Date(tm * 1000);    // 根据时间戳生成的时间对象
//         return (d.getFullYear()) + '-' +
//           (d.getMonth() + 1) + '-' +
//           (d.getDate());
// //        return new Date(parseInt(nS) * 1000).toLocaleString().replace(/:\d{1,2}$/, ' ');
//       }
    }
  };

</script>

<style scoped lang="scss" type="text/scss" rel="stylesheet/scss">
  @import '../../assets/scss/base.scss';

  .new{
    width: px2rem(750);
    @include bg-img('../../assets/img/parentRecord/background');
  }
  .title{
    padding-top: px2rem(40 + 49);
    margin-bottom: px2rem(28);
    text-align: center;
  }
  .head{
  @include bg-img('../../assets/img/parentRecord/tongji');
    /*margin-top: px2rem(20);*/
    margin-left: px2rem(48);
    font-size: px2rem(30);
    height: px2rem(85);
    width: px2rem(185);

  }
  .head1{
  @include bg-img('../../assets/img/parentRecord/detail');
    margin-left: px2rem(48);
    font-size: px2rem(30);
    height: px2rem(85);
    width: px2rem(185);
  }
  .content1{
    border-radius: px2rem(10);
    background-color: rgba(251,246,220,1);
    height: px2rem(688);
    margin-left: px2rem(48);
    margin-right: px2rem(48);
    margin-bottom: px2rem(14);
    padding-top: px2rem(20);
    padding-bottom: px2rem(20);
    padding-left: px2rem(34);
    line-height: px2rem(37);
    overflow-y: auto;
    overflow-x: hidden;
  }
  .content2{
    padding-top: px2rem(34);
    padding-bottom: px2rem(34);
    width: px2rem(655);
    height: px2rem(608 - 34 - 34);
    background-color: rgba(251,246,220,1);
    border-radius: px2rem(10);
    margin-left: px2rem(48);

    .detail{
      margin-left: px2rem(34);
      margin-right: px2rem(34);
      font-size: px2rem(28);
      height: px2rem(538);
      overflow-y: auto;
      overflow-x: hidden;
      -webkit-overflow-scrolling: touch;
    }
  }
  .detail2{
    margin-bottom: px2rem(20);
  }
  p{
    font-size: px2rem(28);
  }
</style>



// WEBPACK FOOTER //
// AboutCourse.vue?5e208b62